<simple-card
  [cardTitle]="'Help shape what\'s next'"
  [enableShadow]="true"
  [backgroundImage]="'/assets/images/bubble-background.png'"
  [showHeader]="false"
  [contentLayout]="'default'"
>
  <div
    #root
    class="feedback-container"
    [style.display]="containerDisplay"
    [style.flex-direction]="containerDirection"
  >
    <div
      class="feedback-icon-container"
      [style.position]="iconContainerPosition"
      [style.margin-top]="iconContainerMarginTop"
    >
      <mat-icon
        svgIcon="lightbulb-on-bold"
        class="feedback-lightbulb-icon"
        [style.position]="iconPosition"
        [style.top]="iconTop"
        [style.right]="iconRight"
      ></mat-icon>
    </div>

    <div class="feedback-content-wrapper">
      <div class="feedback-header">
        <h4 class="feedback-title">Help shape what’s next</h4>
      </div>
      <div class="feedback-content">
        <p class="feedback-body">{{ feedbackBody }}</p>
        <button class="feedback-btn" (click)="onOpenRequested()">Share your feedback*</button>
      </div>

      <div class="feedback-footer" [style.top]="footerTop">
        <p class="feedback-policy-text">*Feedback will not be shared with study teams.</p>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://resource.digital.thermofisher.com/privacy.aspx#:~:text=We%20do%20not%20and%20will,your%20personal%20information%20to%20others."
          class="feedback-policy"
        >
          Global privacy policy
        </a>
      </div>
    </div>
  </div>
</simple-card>
